import { useMutation, useQueryClient } from '@tanstack/react-query';
import { memberUpdate } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useMemberUpdate({
  handleSuccess = () => null,
  handleError = () => null,
} = {}) {
  const queryclient = useQueryClient();
  const Request = useMutation({
    mutationFn: memberUpdate,
    mutationKey: ['memberUpdate'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        handleError();
        return toastEmitter('error', responseData?.error?.message);
      }
      handleSuccess();
      queryclient.invalidateQueries(['getMemberListing']);
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
